import React, { useState } from 'react'
import { PuzzlePieceIcon } from '@heroicons/react/24/outline'
import { Heading, Text, Button } from '../ui'
import GameRankingTab from '../../pages/Marketing/GameRankingTab'
import GameRankingHistoricoTab from '../../pages/Marketing/GameRankingHistoricoTab'
import GameJogarModal from '../../pages/Marketing/GameJogarModal'

interface HomeCacaPalavrasSectionProps {
  onShareResult?: (text: string) => void
}

/**
 * Aba da home com ranking por edição e ranking histórico (campeões gerais).
 */
const HomeCacaPalavrasSection: React.FC<HomeCacaPalavrasSectionProps> = ({
  onShareResult,
}) => {
  const [playModalOpen, setPlayModalOpen] = useState(false)

  const handleShareResult = (text: string) => {
    setPlayModalOpen(false)
    onShareResult?.(text)
  }

  return (
    <div className="space-y-6 py-2">
      <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <Heading as="h2" size="xl" className="text-gray-900 dark:text-white">
            Desafio Possível - Caça-Palavras
          </Heading>
          <Text size="sm" color="muted" className="mt-1">
            Acompanhe o ranking da edição e os maiores campeões no geral.
          </Text>
        </div>
        <Button
          variant="solid"
          className="inline-flex items-center gap-2"
          onClick={() => setPlayModalOpen(true)}
        >
          <PuzzlePieceIcon className="h-5 w-5" />
          Abrir caça-palavras
        </Button>
      </div>

      <div className="grid grid-cols-1 gap-6 xl:grid-cols-2 xl:items-start">
        <section className="min-w-0 rounded-xl border border-gray-200 bg-white p-4 dark:border-gray-700 dark:bg-gray-800 sm:p-5">
          <GameRankingTab
            limit={10}
            hideDate
            hideStatus
            hideTimeUntilCurrentUserPlayed
          />
        </section>
        <section className="min-w-0 rounded-xl border border-gray-200 bg-white p-4 dark:border-gray-700 dark:bg-gray-800 sm:p-5">
          <GameRankingHistoricoTab limit={10} hideBestTime />
        </section>
      </div>

      <GameJogarModal
        open={playModalOpen}
        onClose={() => setPlayModalOpen(false)}
        onShareResult={handleShareResult}
      />
    </div>
  )
}

export default HomeCacaPalavrasSection
